// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"128":"77a128a6","142":"8433803d","419":"08bf2526"}[chunkId] + ".chunk.css";
};